import { Box, Button, Card, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';
import { loadingSpaceA, updateLoadingSpace } from "../../assets/styles";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ReadMore from "./ReadMore";
import { uploadToS3 } from "../../lib/aws_s3";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "80%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const BlogEditing = () => {
    const [resultData, setResultData] = useState([]);
    const [isLoadingBlogs, setIsLoadingBlogs] = useState(false);
    const [isLoadingBlogUpdate, setIsLoadingBlogUpdate] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [selectedBlog, setSelectedBlog] = useState(null);
    const [file, setFile] = useState(null);
    const [content, setContent] = useState('');

    const handleOpen = (blog) => {
        setSelectedBlog(blog);
        setContent(blog.content);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedBlog(null);
        setFile(null);
        setContent('');
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoadingBlogs(true);
            try {
                const response = await fetch(`https://apivsfintech.invtechnologies.in/getblogsdata`);
                if (!response.ok) {
                    throw new Error(`http error status: ${response.status}`);
                }
                const result = await response.json();
                // console.log(result);
                setResultData(result.data);
            } catch (error) {
                console.error("Error fetching blog data:", error);
            } finally {
                setIsLoadingBlogs(false);
            }
        };
        fetchData();
    }, []);

    const handleBlogEdit = async (event) => {
        event.preventDefault();
    
        const title = document.getElementById('edit-title').value;
        if (!content && !title) {
            alert('All fields are mandatory');
            return;
        }
        setIsLoadingBlogUpdate(true);
    
        let imageUrl = selectedBlog.image; // Keep existing image if no new image is provided
    
        // Function to handle file upload and update the blog
        const uploadImageAndUpdateBlog = async () => {
            if (file) {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    const arrayBuffer = reader.result;
                    const buffer = new Uint8Array(arrayBuffer);
                    const fileName = `blogImages/${Date.now()}-${file.name}`;
                    
                    try {
                        imageUrl = await uploadToS3(buffer, fileName); // Assuming you have an uploadToS3 function
                    } catch (error) {
                        console.error('Error uploading image:', error.message);
                        alert('Failed to upload image. Please try again.');
                        setIsLoadingBlogUpdate(false);
                        return;
                    }
                    await updateBlog(); // Proceed with updating the blog after the image upload
                };
                reader.readAsArrayBuffer(file);
            } else {
                await updateBlog(); // Proceed with updating the blog without new image
            }
        };
    
        // Function to update the blog
        const updateBlog = async () => {
            try {
                const response = await fetch(`https://apivsfintech.invtechnologies.in/editBlog/${selectedBlog.slno}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ image: imageUrl, title: title, content: content }),
                });
    
                if (!response.ok) {
                    throw new Error('Blog edit failed');
                } else {
                    alert('Blog edited successfully');
                    window.location.reload();
                }
            } catch (error) {
                console.error('Error editing blog:', error.message);
                alert('Something went wrong. Please try again later');
            } finally {
                setIsLoadingBlogUpdate(false);
            }
        };
    
        await uploadImageAndUpdateBlog(); // Execute the function to handle the whole process
    };
    
    
    const handleDelete = async (id) => {
        setIsLoadingBlogUpdate(true);
        // console.log(id);
        try {
            const response = await fetch(`https://apivsfintech.invtechnologies.in/deleteBlog/${id}`, {
                method: 'DELETE',
            });
            if (!response.ok) {
                throw new Error('Blog Delete failed');
            } else {
                alert('Blog Deleted successfully');
                setIsLoadingBlogUpdate(false);
                window.location.reload();
            }
        } catch (error) {
            console.error('Error Deleteing blog:', error.message);
            alert('something went wrong. please try again later');
            window.location.reload();
            setIsLoadingBlogUpdate(false);
        }
    }

    return (
        <Box>
            <Box sx={{ backgroundColor: "aliceblue" }}>
                {
                    isLoadingBlogs ? <Box style={loadingSpaceA}><CircularProgress /> </Box> :
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 2 }}>
                            {resultData.slice().reverse().map((item, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        px: { xs: 4 },
                                        py: { xs: 2 },
                                        width: { xs: "310px", sm: "80%" },
                                        display: "flex",
                                        flexDirection: { sm: "row", xs: "column" },
                                        gap: 4,
                                    }}
                                >
                                    {item.image ? (
                                        <Box
                                            sx={{
                                                width: { xs: "100%", sm: "50%" },
                                                borderRadius: "10px",
                                                // maxHeight: "20rem"
                                            }}
                                            component="img"
                                            src={item.image}
                                            alt="Bolg Image"
                                        />
                                    ) : null}
                                    <Box sx={{ width: { xs: "100%", sm: "50%" }, position: "relative" }}>
                                        <Button sx={{ position: "absolute", right: 0, top: 0 }} onClick={() => handleOpen(item)} ><EditIcon /></Button>
                                        <Typography sx={{ fontSize: { xs: 17, sm: 23 }, fontWeight: "bold" }}>
                                            {item.title}
                                        </Typography>
                                        <Box p={1} />
                                        <ReadMore content={item.content} maxCharacterCount={500} />
                                    </Box>
                                </Card>
                            ))}
                        </Box>
                }
            </Box>
            {selectedBlog && (
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                            }}
                            noValidate
                            autoComplete="off"
                            onSubmit={handleBlogEdit}
                        >
                            {isLoadingBlogUpdate ? <Box style={updateLoadingSpace} > <CircularProgress size={35} /></Box> :
                                <>
                                    <Box sx={{
                                        width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: 1,
                                    }}>
                                        <TextField
                                            id="outlined-basic"
                                            label='Select Image'
                                            variant="outlined"
                                            type='file'
                                            name='file'
                                            style={{ width: "30%", }}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(event) => setFile(event.target.files[0])}
                                        />
                                        <TextField
                                            id="edit-title"
                                            label="Write Title"
                                            defaultValue={selectedBlog.title}
                                            multiline
                                            rows={1}
                                            style={{ width: '70%' }}
                                        />
                                    </Box>
                                    <ReactQuill
                                        value={content}
                                        onChange={setContent}
                                        style={{ height: '200px', marginBottom: '2rem' }}
                                    />
                                    <Box sx={{ display: "flex", justifyContent: "center" }}>

                                        <Button variant="contained" type='submit' sx={{ marginLeft: 1, marginTop: 2 }}>Update</Button>
                                        <Button variant="contained" color="error" onClick={() => handleDelete(selectedBlog.slno)} sx={{ marginLeft: 1, marginTop: 2 }}>Delete</Button>

                                        <Button variant="contained" color="warning" onClick={() => handleClose()} sx={{ marginLeft: 1, marginTop: 2 }}>Cancel</Button>
                                    </Box>
                                </>}
                        </Box>
                    </Box>
                </Modal>
            )
            }
        </Box >
    );
};
export default BlogEditing;